import { Button } from '@mui/material'
import cn from 'classnames'

const UserTypeSelection = ({ userType, selectUserType }) => {
    const renderButton = (text, value) => {
        return (
            <div className="w-36 md:w-24 mr-2 mb-2 my-auto">
                <Button
                    radius="sm"
                    fullWidth
                    variant={userType === value ? 'contained' : 'outlined'}
                    onClick={() => {
                        userType !== value ? selectUserType(value) : null
                    }}
                    color={'primary'}
                    className={cn(
                        userType === value
                            ? 'bg-primary text-black'
                            : 'dark:!bg-papert bg-white text-primary',
                    )}
                >
                    {text}
                </Button>
            </div>
        )
    }

    return (
        <div className={cn('flex flex-wrap justify-center md:justify-start')}>
            {renderButton('All', 'all')}
            {renderButton('Buyer', 'buyer')}
            {renderButton('Seller', 'seller')}
        </div>
    )
}

export default UserTypeSelection
